/*
 * Copyright (c) 2021 CalAmp Corp. All Rights Reserved
*/
import {makeStyles} from '@material-ui/core';
import {dlsAlt, dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';
import {getAssetDetailsContentStyles} from '../assetdetails/current/assetDetailsContentStyles';

export const sharedStyles = makeStyles((theme: DLSTheme) => {
  const contentStyles = getAssetDetailsContentStyles();
  return {
    container : {
      width          : '100%',
      alignItems     : 'center',
      justifyContent : 'space-around',
      margin         : 'auto',
      textAlign      : 'center',
      minHeight      : 64
    },
    label : {
      ...dlsAlt('typography', 'label2'),
      color         : dlsColor('grey1'),
      textTransform : 'uppercase',
      letterSpacing : '0.05em',
      fontSize      : 11,
      fontWeight    : 700
    },
    value : {
      ...dlsAlt('typography', 'label2'),
      color         : dlsColor('grey2'),
      letterSpacing : '0.05em',
      fontSize      : 11,
      fontWeight    : 500,
      textTransform : 'uppercase'
    },
    date : {
      ...dlsAlt('typography', 'label3'),
      color         : dlsColor('grey2'),
      textTransform : 'uppercase',
      letterSpacing : '0.05em',
      fontWeight    : 500
    },
    // current theme only - a widget is one of the SensorWidgetContainer's
    // wrapped-row tiles (ION-7522), so its own description text lays out as
    // a plain left-aligned row (icon, then label/value/date) instead of the
    // legacy centered column; the tile's own white/grey-bordered surface is
    // applied by the SensorWidgetContainer wrapper, not here ...
    currentContainer : {
      display        : 'flex',
      alignItems     : 'center',
      justifyContent : 'flex-start',
      width          : '100%',
      minHeight      : 'unset',
      textAlign      : 'left',
      gap            : '8px'
    },
    currentLabel : {
      ...contentStyles.label
    },
    currentValue : {
      ...contentStyles.valueText
    },
    // stacks the label/value, date and time in one column beside the
    // widget's icon, so the time sits below the date rather than squeezed
    // in the same row ...
    currentDescription : {
      display       : 'flex',
      flexDirection : 'column',
      minWidth      : 0,
      gap           : '2px'
    },
    currentDate : {
      ...contentStyles.meta
    }
  };
});

export default sharedStyles;
